import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function signixFieldLengthValidator(maxLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const text = control.value == null ? '' : String(control.value);
    const utf8Length = new TextEncoder().encode(text).length;
    return utf8Length <= maxLength ? null : {
      signixFieldTooLong: {
        maxLength,
        currentLength: utf8Length,
        trimBy: utf8Length - maxLength,
      },
    };
  };
}
